import { render } from "./SchemaSolutionPanel.vue?vue&type=template&id=71b48908&scoped=true"
import script from "./SchemaSolutionPanel.vue?vue&type=script&lang=js"
export * from "./SchemaSolutionPanel.vue?vue&type=script&lang=js"

import "./SchemaSolutionPanel.vue?vue&type=style&index=0&id=71b48908&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b48908"]])

export default __exports__